import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

// Compact replacement for the old full-width info Alert banner on OUber
// pages — same message/description content, shown on hover/focus instead
// of taking up a permanent block of vertical space.
const OuberPageInfoIcon = ({ message, description }) => (
  <Tooltip
    overlayClassName="ouber-page-info-tooltip"
    title={
      <>
        {message && (
          <div className="ouber-page-info-tooltip__title">{message}</div>
        )}
        {description && (
          <div className="ouber-page-info-tooltip__desc">{description}</div>
        )}
      </>
    }
  >
    <InfoCircleOutlined
      className="ouber-page-info-icon"
      aria-label={typeof message === "string" ? message : "Page information"}
      tabIndex={0}
    />
  </Tooltip>
);

export default OuberPageInfoIcon;
